namespace $.$$ {

	export class $shm_tests_scenario extends $.$shm_tests_scenario {

		data() {
			return this.result() as $shm_tests_app_result | null
		}

		player_view() {
			return this.player() as $shm_tests_player | null
		}

		steps() {
			return this.data()?.steps ?? []
		}

		page_title() {
			return this.display_title() || this.data()?.scenario.title || 'Сценарий'
		}

		info_text() {
			const data = this.data()
			if( !data ) return ''
			const commit = data.source.commit ? data.source.commit.slice( 0, 8 ) : 'unknown'
			return [
				`Статус: ${ data.run.status }`,
				`Длительность: ${ this.duration( data.run.duration_ms ) }`,
				`Commit: ${ commit }${ data.source.dirty ? ' (dirty)' : '' }`,
				`Сценарий: ${ data.runner.script }`,
			].join( '\n\n' )
		}

		step_rows() {
			return this.steps().length
				? this.steps().map( ( _, index ) => this.Step( String( index ) ) )
				: [ this.Empty() ]
		}

		step_title( id: string ) {
			const index = Number( id )
			const step = this.steps()[ index ]
			if( !step ) return ''
			return `${ index + 1 }. ${ step.title }`
		}

		step_current( id: string ) {
			return Number( id ) === this.player_view()?.current_index()
		}

		@ $mol_action
		override step_select( id: string, next?: Event ) {
			if( next === undefined ) return null
			const player = this.player_view()
			if( !player ) return next
			this.benchmarks_open( false )
			this.screenshots_open( false )
			const index = Number( id )
			if( !player.video_uri() ) {
				player.play_step_index( index )
				player.playing( false )
				return next
			}
			if( player.playing() && player.play_step_index() === index ) {
				player.play_step_index( -1 )
				player.playing( false )
			} else {
				player.loop_step( index )
			}
			return next
		}

		duration( milliseconds: number ) {
			return milliseconds < 1000 ? `${ milliseconds } мс` : `${ ( milliseconds / 1000 ).toFixed( 1 ) } с`
		}

	}

}
